import { get } from 'lodash';

/**
 * Resolve an element's visibility toggle across a base -> subsection inheritance
 * chain. Reads each path's `enabled` flag in order and returns the first one
 * that is an explicit boolean; if none is set the element defaults to visible.
 *
 * Pass element paths most-specific first (the subsection, then the base it
 * inherits from), mirroring the CSS `var(--subsection, var(--base, default))`
 * fallback used for the matching styles — so a base toggle cascades to its
 * subsections until each sets its own.
 *
 * @param {Object} elements - theme.elements (may be undefined)
 * @param {...string} elementPaths - element paths, most specific first
 * @returns {boolean}
 */
export default function resolveInheritedEnabled(elements, ...elementPaths) {
  for (const path of elementPaths) {
    const value = get(elements, `${path}.enabled`);
    if (typeof value === 'boolean') return value;
  }
  return true;
}
